import Label from '../../../../ui/label';
import { useDispatch } from 'react-redux';
import LoadingCategory from '../../../../ui/loading-category';
import ErrorFetch from '../../../../ui/error-fetch-category';
import { FluentPayment28Regular } from '../../../../../assets/icon/iconify';
import { useMediaQuery } from '../../../../../hooks/common/use-media-query';
import { useIsCompleteProposalAs } from '../../../../../hooks/proposal/use-state-checker-proposal';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { useMemo } from 'react';
import { setSelectedFundingArrangementsBox } from '../../../../../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import Checkbox from '../../../../ui/checkbox';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

export default function ClientInputFundingArrangements() {

    const { 
        modeOfPayment, 
        isLoadingModeOfPayment, 
        isErrorModeOfPayment, 
        isFetchingModeOfPayment 
    } = useQueries();
    const { modeOfPayment: selectedModeOfPayment } = useProposalTypeData()
    const isLoading: boolean = isLoadingModeOfPayment || isFetchingModeOfPayment;

    const mappedOptions: SubTypeOption[] = useMemo(() =>
            modeOfPayment?.map(({ id, name }) => ({
                id,
                name
            })) ?? [],
        [modeOfPayment]
    );

    const dispatch = useDispatch();
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const iconSize: number = isDesktop ? 16 : 15;
    const isComplete = useIsCompleteProposalAs();

    const handleChangeModeOfPayment = (e: React.ChangeEvent<HTMLInputElement>, option: SubTypeOption) => {
        dispatch(setSelectedFundingArrangementsBox(option));
    };

    return (
        <div>
            <div className="flex space-x-2 items-center mb-1">
                <div className="bg-[#186db233] p-1 rounded">
                    <FluentPayment28Regular
                        width={iconSize}
                        height={iconSize}
                    />
                </div>
                <Label
                    label="Mode of Payment"
                    fontWeight="font-semibold text-gray-800"
                    fontSize="text-xs"
                    requiredText=" *"
                    isRequired={true}
                />
            </div>
            <div className="space-y-2">
                <div className="grid grid-cols-2 gap-2">
                    {isLoading ? (
                        <LoadingCategory />
                    ) : isErrorModeOfPayment ? (
                        <ErrorFetch />
                    ) : (
                        mappedOptions.map((option) => {
                            const isSelected = selectedModeOfPayment?.id === option.id;
                            const isDisabled = !isComplete;
                            return (
                                <Checkbox
                                    key={option.id}
                                    disabled={isDisabled} 
                                    option={option} 
                                    isSelected={isSelected} 
                                    onChange={handleChangeModeOfPayment}
                                />
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
}